import { useNavigate } from "react-router-dom";
import { SelectList } from "../../../../../components/Functional";
import { LIST_TYPES } from "../../../../../constants/listTypes";
import { FETCH_LIST_ITEMS as fetchListitems } from "../../../../../graphql/query/ListItems";

const Actions = (props = {}) => {
  const { listId, workingListId } = props;
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap gap-2 sm:gap-4">
      <SelectList.RemoveSelected {...props} />
      <SelectList.ClearList {...props} listId={listId || workingListId} />
      <SelectList.CopyList
        {...props}
        listId={listId || workingListId}
        typeId={LIST_TYPES.ARTWORK}
        sourceTypeId={LIST_TYPES.ARTWORK}
        onSuccess={() => {
          props?.onSuccess?.();
          navigate("/artworks?status=imageSelectListWorking");
        }}
      />
      {listId ? (
        <SelectList.ExitEditMode
          onSuccess={() => {
            props?.onSuccess?.();
            navigate("/artworks?status=selectListSaved");
          }}
        />
      ) : (
        <SelectList.SaveList
          {...{
            ...props,
            typeId: LIST_TYPES.ARTWORK,
            onSuccess: () => {
              props?.onSuccess?.();
              navigate("/artworks?status=selectListSaved");
            },
          }}
        />
      )}
    </div>
  );
};

const tableProps = (props = {}) => {
  const { listId, workingListId } = props;
  const finalListId = listId || workingListId;

  const tableProps = {
    dataKey: "listItems",
    FETCH_QUERY: fetchListitems({
      item: { artists: {}, imagesSummary: { imgT: {} } },
    }),
    fetchPolicy: "network-only",
    skip: () => !finalListId,
    variables: {
      listId: finalListId,
    },
  };

  return tableProps;
};

export { Actions, tableProps };
